import { AbstractControl } from '@angular/forms';
import { calculateAge, dobRegex } from './util';

export default function invalidCharacter(char: string) {
  return (control: AbstractControl) => {
    if (control && control.value) {
      const value = control.value as string;
      if (value.indexOf(char) > -1) {
        return {
          invalidCharacter: true,
        };
      }
    }
    return null;
  };
}
